import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { enableProdMode } from '@angular/core';
import { Environment } from './app/environment/environment';
// IMPORTA ANTES do AppModule: patcha `matDatepickerAnimations.transformPanel`
// pra usar scale uniforme (JEMS3) em vez do scaleY default do Material.
import './app/patches/datepicker-animation-override';
import { AppModule } from './app/app.module';

if (Environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule).catch(err => console.log(err));
